import { Component, Output, EventEmitter, inject } from '@angular/core';
import { UnsubscriberClass, IAction, ActionType, StoreLoader, LoaderSpinnerComponent } from '@aston/foundation';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import * as DunningActionDetailStoreSelectors from 'apps/middle/src/app/root-store/dunning-action-detail-store/selectors';

@Component({
	selector: 'dunning-action-postal-costs-modal',
	templateUrl: './dunning-action-postal-costs-modal.component.html',
	imports: [LoaderSpinnerComponent, TranslateModule, AsyncPipe]
})
export class DunningActionSendingCostsModalComponent extends UnsubscriberClass {
	private store = inject(Store);

	@Output() resultEvent = new EventEmitter<IAction>();

	loader = new StoreLoader(
		this.store.select(DunningActionDetailStoreSelectors.selectSendingCostsBalanceIsLoading),
		this.store.select(DunningActionDetailStoreSelectors.selectSendingCostsBalanceError));

	balance$ = this.store.select(DunningActionDetailStoreSelectors.selectSendingCostsBalance);
	canSubmit$ = combineLatest([
		this.store.select(DunningActionDetailStoreSelectors.selectSendingCostsBalanceIsLoading),
		this.store.select(DunningActionDetailStoreSelectors.selectSendingCostsBalanceError),
		this.balance$
	]).pipe(
		map(([loading, error, balance]) => !loading && !error && balance && !balance.isMonthlyMaxAmountReached));

	onSubmit() {
		// caught in DunningActionDetailStoreEffects::onFormOpen$
		this.resultEvent.emit({type: ActionType.SUBMIT, value: true});
	}

	onCancel() {
		this.resultEvent.emit({type: ActionType.CANCEL, value: undefined});
	}

	onClose() {
		// caught in DunningActionDetailStoreEffects::onFormOpen$
		this.resultEvent.emit({type: ActionType.CLOSE, value: undefined});
	}
}
